import {Component, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {unitDashboardCallEventAnimations} from "../animations/unit-dashboard-call-event-animations";
import {CallEvent, CallEventState} from "../models/call-event";
import {DxTooltipComponent} from "devextreme-angular";

@Component({
  selector: 'app-unit-call-event',
  templateUrl: './unit-call-event.component.html',
  styleUrl: './unit-call-event.component.scss',
  animations: unitDashboardCallEventAnimations
})
export class UnitCallEventComponent implements OnDestroy {

  @Input() set expandedEventId(value: string | null) {
      if (this._expandedEventId !== value) {
          this.imageTooltip?.instance?.hide();
      }
      this._expandedEventId = value;
  }
  get expandedEventId(): string | null { return this._expandedEventId; }
  private _expandedEventId: string | null = null;
  @Input() event: CallEvent | null = null;

  @Output() callEventClicked: EventEmitter<string> = new EventEmitter();

  @ViewChild('imageTooltip') imageTooltip!: DxTooltipComponent;

  hoveredImageUrl: string | null = null;

  protected readonly CallEventState = CallEventState;

  readonly timePeriodKeys: Record<string, string> = {
      morning: 'Dashboard.TimePeriodMorning',
      afternoon: 'Dashboard.TimePeriodAfternoon',
      evening: 'Dashboard.TimePeriodEvening'
  };

  private hideTimer: any;

  getTimePeriod(timestamp: number): string {
      const hour = new Date(timestamp * 1000).getHours();
      if (hour >= 6 && hour < 12) return 'morning';
      if (hour >= 12 && hour < 18) return 'afternoon';
      return 'evening';
  }

  onImageHover(event: MouseEvent, imageUrl: string) {
      clearTimeout(this.hideTimer);
      this.hoveredImageUrl = imageUrl;
      const target = event.currentTarget as HTMLElement;
      const instance = this.imageTooltip?.instance;
      if (instance) {
          instance.option('target', target);
          instance.show(target);
      }
  }

  onImageLeave() {
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
          this.imageTooltip?.instance?.hide();
      }, 120);
  }

  ngOnDestroy() {
      clearTimeout(this.hideTimer);
  }
}
